export default __webpack_public_path__ + "img/BB_RTK_250MA_EF.2e477c22f52598f6c818678b254e24a9.jpg";